import { Truck, MapPin, Clock, DollarSign } from 'lucide-react';

export default function ShippingInfo() {
  return (
    <div className="shipping-info-page">
      <div className="shipping-info-container">
        {/* Header */}
        <div className="shipping-info-header">
          <h1>Shipping Information</h1>
          <p>Everything you need to know about our shipping process.</p>
        </div>

        {/* Quick Info Cards */}
        <div className="shipping-info-cards">
          <div className="shipping-info-card">
            <Truck className="shipping-info-card-icon" />
            <h3>Fast Delivery</h3>
            <p>Standard delivery in 3-5 business days</p>
          </div>

          <div className="shipping-info-card">
            <MapPin className="shipping-info-card-icon" />
            <h3>Track Your Order</h3>
            <p>Real-time tracking for all shipments</p>
          </div>

          <div className="shipping-info-card">
            <DollarSign className="shipping-info-card-icon" />
            <h3>Free Shipping</h3>
            <p>On orders over $50</p>
          </div>

          <div className="shipping-info-card">
            <Clock className="shipping-info-card-icon" />
            <h3>Express Available</h3>
            <p>1-2 day delivery option</p>
          </div>
        </div>

        {/* Content */}
        <div className="shipping-info-content">
          <section className="shipping-info-section">
            <h2>Shipping Methods</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </p>

            <div className="shipping-info-table">
              <div className="shipping-info-table-row">
                <div className="shipping-info-table-cell">
                  <strong>Standard Shipping</strong>
                </div>
                <div className="shipping-info-table-cell">3-5 business days</div>
                <div className="shipping-info-table-cell">$5.99</div>
              </div>
              <div className="shipping-info-table-row">
                <div className="shipping-info-table-cell">
                  <strong>Express Shipping</strong>
                </div>
                <div className="shipping-info-table-cell">1-2 business days</div>
                <div className="shipping-info-table-cell">$12.99</div>
              </div>
              <div className="shipping-info-table-row">
                <div className="shipping-info-table-cell">
                  <strong>Overnight Shipping</strong>
                </div>
                <div className="shipping-info-table-cell">Next business day</div>
                <div className="shipping-info-table-cell">$24.99</div>
              </div>
            </div>
          </section>

          <section className="shipping-info-section">
            <h2>Processing Time</h2>
            <p>
              Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
          </section>

          <section className="shipping-info-section">
            <h2>Shipping Restrictions</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
            <ul className="shipping-info-list">
              <li>We ship to all 50 US states</li>
              <li>International shipping available to select countries</li>
              <li>PO boxes accepted for standard shipping</li>
              <li>Some items may have shipping restrictions</li>
            </ul>
          </section>

          <section className="shipping-info-section">
            <h2>Order Tracking</h2>
            <p>
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
          </section>

          <section className="shipping-info-section">
            <h2>Delivery Issues</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
          </section>

          <section className="shipping-info-section">
            <h2>International Shipping</h2>
            <p>
              Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.
            </p>
          </section>

          <section className="shipping-info-section">
            <h2>Contact Us</h2>
            <p>
              For shipping inquiries, please contact us at shipping@example.com or call +1 (234) 567-8900
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}